/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, FormHelperText
} from '@material-ui/core';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "PRICENEGOTIATIONAUDITREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'priceProposedDate',
        numeric: false,
        disablePadding: false,
        label: 'Proposed Date',
        align: "center"
    },
    {
        id: 'collectionCenter',
        numeric: false,
        disablePadding: false,
        label: 'FCC',
        align: "center"
    },
    {
        id: 'cropName',
        numeric: true,
        disablePadding: false,
        label: 'Crop',
        align: "center"
    },
    {
        id: 'quantity',
        numeric: true,
        disablePadding: false,
        label: 'Forecast Qty (Kg)',
        align: "center"
    },
    {
        id: 'remainingQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Forecast Remaining Qty (Kg)',
        align: "center"
    },
    {
        id: 'acceptedQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Accepted Qty (Kg)',
        align: "center"
    },
    {
        id: 'remainQty',
        numeric: true,
        disablePadding: false,
        label: 'Remaining Qty (Kg)',
        align: "center"
    },
    {
        id: 'returnQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Return Qty (Kg)',
        align: "center"
    },
    {
        id: 'proposedPrice',
        numeric: true,
        disablePadding: false,
        label: 'Proposed Price(LKR)',
        align: "center"
    },
    {
        id: 'secondProposedPrice',
        numeric: true,
        disablePadding: false,
        label: 'Reorder Price(LKR)',
        align: "center"
    },
    {
        id: 'approvedPrice',
        numeric: true,
        disablePadding: false,
        label: 'Approved Price(LKR)',
        align: "center"
    },
    {
        id: 'realizedPrice',
        numeric: true,
        disablePadding: false,
        label: 'Realized Price(LKR)',
        align: "center"
    },
    {
        id: 'vpuApprovedUser',
        numeric: true,
        disablePadding: false,
        label: 'FDC Approved /Rejected User',
        align: "center"
    },
    {
        id: 'vccApprovedUser',
        numeric: true,
        disablePadding: false,
        label: 'FCC Approved /Rejected User',
        align: "center"
    },
    {
        id: 'hartiDate',
        numeric: true,
        disablePadding: false,
        label: 'Harti Price Last Updated Date',
        align: "center"
    },
    {
        id: 'min',
        numeric: true,
        disablePadding: false,
        label: 'Min',
        align: "center"
    },
    {
        id: 'max',
        numeric: true,
        disablePadding: false,
        label: 'Max',
        align: "center"
    },
    {
        id: 'secondProposedPriceStatus',
        numeric: true,
        disablePadding: false,
        label: 'Reorder Price Status',
        align: "center"
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        align: "center"
    },
];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    //Print
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align="left"
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function PriceNegotiationAuditReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();

    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Crop Wise Availability'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [priceNegotiation, setPriceNegotiation] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, priceNegotiation.length - page * rowsPerPage);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        cropCategoryID: 0,
        cropID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const priceNegotiationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one fresh collection center')
            .required('Please select at least one fresh collection center'),
        cropCategoryID: Yup.array()
            .min(1, 'Please select at least one product category')
            .required('Please select at least one product category'),
        cropID: Yup.array()
            .min(1, 'Please select at least one product')
            .required('Please select at least one product'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select From Date').required('Start From Date required'),
        toDate: Yup.date().min(1).min(1, 'Please Select To Date').required('Start To Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: '',
        operationEntity: '',
        cropCategory: '',
        crop: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: priceNegotiationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRICENEGOTIATIONAUDITREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        let model = {
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            cropID: selectedProductOptions.map(x => x).join(',').toString(),
            fromDate: fromDate,
            toDate: toDate
        }
        var response = await services.GetPriceNegotiationAuditReportData(model);
        let final = response.filter(x => x.quantity > 0)
        let res = _.cloneDeep(final);
        res.forEach(x => {
            x.priceProposedDate = x.priceProposedDate.split('T')[0];
            x.quantity = parseFloat(x.quantity).toFixed(2);
        });

        //experimenting
        let found = [];
        const resultTwo = await services.GetMappedMarketPrice(selectedOptions.map(x => x).join(',').toString(), new Date(fromDate).toISOString(), new Date(toDate).toISOString());
        res.forEach(x => {
            let find = resultTwo.find(y => y.productID == x.cropID && y.operationEntityID == x.operationEntityID)
            if (find) {
                let latestRow = find.priceModel.reduce((a, b) => {
                    return new Date(a.date) > new Date(b.date) ? a : b;
                });
                x.minPrice = latestRow.priceMin;
                x.maxPrice = latestRow.priceMax;
                x.date = latestRow.date;
            }
            else {
                x.minPrice = 0
                x.maxPrice = 0
                x.date = '0';
            }
        })

        setPriceNegotiation(res);
        createDataForExcel(res);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setPriceNegotiation([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        } else {
            setSelectedOptions([])
            setPriceNegotiation([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        }
    }

    useEffect(() => {
        if (selectedOptions.length > 0) {
            trackPromise(GetProductCategoties());
        } else {
            trackPromise(GetAllGroups());
        }
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [formik.values.cropID]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [toDate]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [fromDate]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [selectedOptions]);

    useEffect(() => {
        setPriceNegotiation([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPriceNegotiation([]);
    }, [selectedProductOptions])

    useEffect(() => {
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);


    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties();
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(priceNegotiation);
        var settings = {
            sheetName: 'Audit Report',
            fileName: 'Price Negotiation Audit Report_' + new Date(fromDate).toISOString().split('T')[0] + '-' + new Date(toDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Audit Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === factory.length ? [] :
                    factory.map((option) => option.value)
            );
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productcatogery.length ? [] :
                    productcatogery.map((option) => option.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(
                selectedProductOptions.length === product.length ? [] :
                    product.map((option) => option.value)
            );
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Price Proposed Date': x.priceProposedDate,
                    'FCC': x.factoryName,
                    'Crop': x.cropName,
                    'Forecast Qty (Kg)': parseFloat(x.quantity).toFixed(2),
                    'Forecast Remaining Qty (Kg)': x.remainingQuantity.toFixed(2),
                    'Accepted Qty (Kg)': x.acceptedQuantity.toFixed(2),
                    'Remaining Qty (Kg)': x.remainQty.toFixed(2),
                    'Return Qty (Kg)': x.returnQuantity.toFixed(2),
                    'Proposed Price(LKR)': x.proposedPrice.toFixed(2),
                    'Second Proposed Price(LKR)': x.secondProposedPrice.toFixed(2),
                    'Approved Price(LKR) ': x.approvedPrice.toFixed(2),
                    'Realized Price(LKR)': x.realizedPrice.toFixed(2),
                    'FDC Approved User': x.vpuApprovedUser,
                    'FCC Approved User ': x.vccApprovedUser,
                    'Harti Price Last Updated Date': x.date == '0' ? "-" : new Date(x.date).toISOString().split('T')[0],
                    'Min Price': x.minPrice == 0 ? "-" : x.minPrice.toFixed(2),
                    'Max Price': x.maxPrice == 0 ? "-" : x.maxPrice.toFixed(2),
                    'Second Proposed Price Status': x.secondProposedPriceStatus == 0 ? "Not Set" : x.secondProposedPriceStatus == 1 ? "Pending" : x.secondProposedPriceStatus == 2 ? "Approved" : x.secondProposedPriceStatus == 3 ? "Rejected" : "",
                    'Status': x.status == 0 ? "Not Set" : x.status == 1 ? "Pending" : x.status == 2 ? "Pending" : x.status == 3 ? "Approved" : x.status == 3 ? "Rejected" : ""
                }
                res.push(vr);
            });

            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups.groupName,
            operationEntity: facName.map(x => x).join(','),
            cropCategory: categoryName.map(x => x).join(','),
            crop: productName.map(x => x).join(','),
            fromDate: new Date(fromDate).toISOString().split('T')[0],
            toDate: new Date(toDate).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Price Negotiation Audit Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/priceNegotiationAuditReport"}
                        btname="Add"
                        pageName="Price Negotiation Audit Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropCategoryID && errors.cropCategoryID && (
                                            <FormHelperText>{errors.cropCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} align='left'>
                                    <FormControl fullWidth error={Boolean(touched.cropID && errors.cropID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropID && errors.cropID && (
                                            <FormHelperText>{errors.cropID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled} // Disable future dates
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />

                                    </LocalizationProvider>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled} // Disable future dates
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }} // Make the input field readonly
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {priceNegotiation.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={priceNegotiation.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(priceNegotiation, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell component="th" id={labelId} scope="row" >
                                                                                    {new Date(row.priceProposedDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell >{row.factoryName}</TableCell>
                                                                                <TableCell >{row.cropName}</TableCell>
                                                                                <TableCell align='center'>{parseFloat(row.quantity).toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.remainingQuantity.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.acceptedQuantity.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.remainQty.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.returnQuantity.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.proposedPrice.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.secondProposedPrice == 0 ? "-" : row.secondProposedPrice.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.approvedPrice == 0 ? "-" : row.approvedPrice.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.realizedPrice == 0 ? "-" : row.realizedPrice.toFixed(2)}</TableCell>
                                                                                <TableCell >{row.approvedPrice == 0 ? "-" : row.vpuApprovedUser}</TableCell>
                                                                                <TableCell >{row.vccApprovedUser == null ? "-" : row.vccApprovedUser}</TableCell>
                                                                                <TableCell >{row.date == '0' ? "-" : new Date(row.date).toLocaleDateString('en-US',
                                                                                    { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell align='center'>{row.minPrice == 0 ? "-" : row.minPrice.toFixed(2)}</TableCell>
                                                                                <TableCell align='center'>{row.maxPrice == 0 ? "-" : row.maxPrice.toFixed(2)}</TableCell>
                                                                                <TableCell >
                                                                                    {row.secondProposedPriceStatus == 0 ? <Chip label="Not Set" variant="outlined" />
                                                                                        : row.secondProposedPriceStatus == 1 ? <Chip label="Pending" variant="outlined" />
                                                                                            : row.secondProposedPriceStatus == 2 ? <Chip label="Approved" color="primary" />
                                                                                                : row.secondProposedPriceStatus == 3 ? <Chip label="Rejected" color="error" /> : "-"}
                                                                                </TableCell>
                                                                                <TableCell >
                                                                                    {row.status == 0 ? <Chip label="Not Set" variant="outlined" />
                                                                                        : row.status == 1 ? <Chip label="Pending" variant="outlined" />
                                                                                            : row.status == 2 ? <Chip label="Pending" variant="outlined" />
                                                                                                : row.status == 3 ? <Chip label="Approved" color="primary" />
                                                                                                    : row.status == 4 ? <Chip label="Rejected" color="error" /> : "-"}

                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={priceNegotiation.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Price Negotiation Audit Report" />}</>
                        </Form>
                    </FormikProvider>
                    {priceNegotiation.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Price Negotiation Audit Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    priceNegotiation={priceNegotiation}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}